/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../Context/app-state';
import './Header.css';
import BasicAlerts from './snackbar';

const Header = () => {
  const { filters, setFilters, chosens } = React.useContext(AppContext);
  const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
    const { value } = event.target as HTMLInputElement;
    setFilters({ ...filters, search: value });
  };
  const res = chosens.length;
  return (
    <div className="App-header">
      <nav className="nav-bar">
        <Link to="/">
          {' '}
          <a
            className="logo"
            style={{
              backgroundImage: `url(./assets/svg/tree.svg)`,
            }}
          />
        </Link>
        <nav>
          <Link to="/toys">Игрушки</Link>
        </nav>
        <nav>
          <Link to="/tree">Ёлка</Link>
        </nav>
      </nav>
      <div className="header-controls">
        <form action="" method="post" className="search">
          <input
            type="search"
            autoFocus
            onChange={handleInput}
            autoComplete="off"
            placeholder="Введите название игрушки..."
            className="input"
          />
          <span className="submit" />
        </form>
        <div
          className="header-controls-select"
          style={{
            backgroundImage: `url(./assets/svg/ball-2.svg)`,
          }}
        >
          <span className="App-toys__chosen">
            {res >= 21 && BasicAlerts()}
            {res}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Header;
